import { useLayoutEffect } from 'react';

type FullScreenLoaderListener = (activeLoaderCount: number) => void;

let activeLoaderCount = 0;
const listeners = new Set<FullScreenLoaderListener>();

const notify = () => {
  listeners.forEach(listener => listener(activeLoaderCount));
};

export const registerFullScreenLoader = () => {
  activeLoaderCount += 1;
  document.body.dataset.dhsFullPageLoadingCount = String(activeLoaderCount);
  notify();

  return () => {
    activeLoaderCount = Math.max(0, activeLoaderCount - 1);
    if (activeLoaderCount === 0) {
      delete document.body.dataset.dhsFullPageLoadingCount;
    } else {
      document.body.dataset.dhsFullPageLoadingCount = String(activeLoaderCount);
    }
    notify();
  };
};

export const subscribeToFullScreenLoaders = (listener: FullScreenLoaderListener) => {
  listeners.add(listener);
  listener(activeLoaderCount);

  return () => {
    listeners.delete(listener);
  };
};

export const useFullScreenLoaderRegistration = (isLoading: boolean) => {
  useLayoutEffect(() => {
    if (!isLoading) return;

    return registerFullScreenLoader();
  }, [isLoading]);
};
